export function DashboardInReview() {
  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
        <div className='w-full flex flex-col items-center'>
          <div className='w-full flex flex-col items-center gap-4'>
            <p className='font-bold text-xl text-center'>No Additional Step Required at this Time.</p>
          </div>
        </div>
      </div>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <p className='font-bold text-xl text-[#646464]'>Your refund request is currently under review by our team. If we need any more information from you, we'll reach out directly. We appreciate your patience and will update you as soon as we can.</p>
      </div>
    </div>
  )
}